import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { handleGetJobs } from './dashboardThunk';
import { IJobs } from '~/utils/interface/job';
import { DEFAULT_PAGE } from '~/utils/constants/jobs';
import { SortField } from '~/utils/types/common';

export interface JobState {
  jobs: Array<IJobs>;
  currentPage: number;
  totalPages: number;
  totalItems: number;
  needRefreshData: boolean;
  filter: IJobFilter;
}

interface IJobFilter {
  sort?: Array<SortField>;
  page?: number;
  limit?: number;
}

const initialState: JobState = {
  jobs: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  totalItems: 0,
  needRefreshData: false,
  filter: {
    sort: [],
    page: 1,
    limit: 5,
  },
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setFilter(state, action: PayloadAction<IJobFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(handleGetJobs.fulfilled, (state, action) => {
      state.jobs = [...action.payload.responses];
      state.currentPage = action.payload.pagination.page;
      state.totalPages = action.payload.pagination.totalPages;
      state.totalItems = action.payload.pagination.totalItems;
      state.needRefreshData = false;
    });
  },
});

export const dashboardActions = dashboardSlice.actions;

const dashboardReducer = dashboardSlice.reducer;
export default dashboardReducer;
